import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "py-5",
  id: "tracking"
}
const _hoisted_2 = { class: "container pb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", { class: "border-bottom mb-2" }, [
  /*#__PURE__*/_createElementVNode("h6", null, [
    /*#__PURE__*/_createElementVNode("small", { class: "fw-light" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left small" }),
      /*#__PURE__*/_createTextVNode(" Back")
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "mx-3" }),
    /*#__PURE__*/_createTextVNode(" Integration of mHealth in Central District to teach mothers how to stop Postpartum haemorrhage ")
  ])
], -1)
const _hoisted_4 = { class: "timeline_section" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "INNOVATION TIMELINE", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Timeline, {
          value: _ctx.events,
          align: "left"
        }, {
          content: _withCtx((slotProps) => [
            _createVNode(_component_Card, { class: "mb-3" }, {
              title: _withCtx(() => [
                _createElementVNode("h6", null, _toDisplayString(slotProps.item.title), 1)
              ]),
              content: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(slotProps.item.content), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ])
  ]))
}